module.exports = __webpack_public_path__ + "static/media/history-titles-icon.24aa74b1.svg";